import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Languages } from 'lucide-react';

const languages = [
  { 
    code: 'en', 
    name: 'English',
    flag: '🇺🇸'
  },
  { 
    code: 'fr', 
    name: 'Français',
    flag: '🇫🇷'
  },
  { 
    code: 'de', 
    name: 'Deutsch',
    flag: '🇩🇪'
  },
  { 
    code: 'es', 
    name: 'Español',
    flag: '🇪🇸'
  }
];

export const LanguageSelector = () => {
  const { currentLanguage, changeLanguage } = useLanguage();
  
  const currentLang = languages.find(lang => lang.code === currentLanguage) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="sm" 
          className="gap-2 hover:text-primary transition-colors"
        >
          <span className="text-xl">{currentLang.flag}</span>
          <Languages className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-card border-border">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={`cursor-pointer ${
              currentLanguage === lang.code 
                ? 'bg-primary/20 text-primary' 
                : 'hover:bg-secondary'
            }`}
          >
            <span className="text-xl mr-3">{lang.flag}</span>
            <span>{lang.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
